export default __webpack_public_path__ + "static/media/LightFixtures-Stacklab1763_.1f12d1a7.jpg";